/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CloneDeviceDto,
  DeviceBreadcrumbsDto,
  DevicesV2ControllerCloneDevicePathParameters,
  DevicesV2ControllerFindAllParams,
  DevicesV2ControllerFindAllPathParameters,
  DevicesV2ControllerGetAvailableFiltersParams,
  DevicesV2ControllerGetAvailableFiltersPathParameters,
  DevicesV2ControllerGetDeviceBreadcrumbsPathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DevicesV2Service {
  private readonly http = inject(HttpClient);
  /**
   * Retrieves a list of devices for a client
   * @summary Get list of devices
   */

  findAll<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesV2ControllerFindAllPathParameters,
    params?: DevicesV2ControllerFindAllParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Retrieves available filters for devices
   * @summary Get available filters
   */

  getAvailableFilters<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesV2ControllerGetAvailableFiltersPathParameters,
    params?: DevicesV2ControllerGetAvailableFiltersParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/filters`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Get breadcrumbs path for a device or child device
   */

  getDeviceBreadcrumbs<TData = DeviceBreadcrumbsDto>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesV2ControllerGetDeviceBreadcrumbsPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/${deviceId}/breadcrumbs`);
  }
  /**
   * Copies a device
   * @summary Clone device
   */

  cloneDevice<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesV2ControllerCloneDevicePathParameters,
    cloneDeviceDto: CloneDeviceDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v2/clients/${clientId}/devices/${deviceId}/clone`, cloneDeviceDto);
  }
}
